<template>
  <q-dialog
    :value="show"
    persistent
    :maximized="true"
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card class="full-height">
      <q-btn
        dense
        unelevated
        icon="close"
        class="fixed z-max closeBtn bg-white"
        @click="$emit('close')"
      />
      <q-card-section class="q-pa-none full-width full-height">
        <GmapMap
          v-if="show"
          class="full-width full-height"
          :center="position"
          :zoom="18"
          :options="{
            fullscreenControl: false,
            mapTypeControl: false,
          }"
        >
          <GmapMarker
            :position="position"
            :clickable="true"
            :draggable="true"
            @click="center = position"
          />
        </GmapMap>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  model: {
    prop: 'show',
    event: 'close',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.closeBtn {
  top: 16px;
  right: 16px;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
}
</style>
